// extracted by mini-css-extract-plugin
export default {"loading-outlined":"LoadingOutlined_loading-outlined__Ox5Ig","loadingCircle":"LoadingOutlined_loadingCircle__wsr9K"};